(function (api, $) {
  "use strict";
  var $navbar = $("#header");
  api.onScroll = function () {
    $navbar.toggleClass("slim", window.scrollY > 0);
  };
  api.init = function () {
    $("html").removeClass("no-js");

    const swiper = new Swiper(".swiper-container", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    $("#database").DataTable({
      order: [[0, "asc"]],
      language: __jsVars.l10n.DataTable[__jsVars.l10n.lang] || [],
    });

    api.onScroll();
  };

  //document ready
  $(function () {
    api.init();
    $(window).on("scroll", api.onScroll);
  });
})(window, jQuery);
